import React, { useState } from 'react';
import KardexEstAdmision from '../kardex/KardexEstAdmision';
import KardexEstMatriculacion from '../kardex/KardexEstMatriculacion';
import { Users, GraduationCap } from 'lucide-react';

/**
 * JefaturaConsultasEstudiantes - Vista consolidada de estudiantes para Jefatura.
 * Implementación de la vista de monitoreo de padrón estudiantil.
 */
export default function JefaturaConsultasEstudiantes({ readOnly = false }) {
    const [activeTab, setActiveTab] = useState('admision');

    return (
        <div>
            {/* Header: Cambiamos p-6 por px-6 pt-6 pb-2 para eliminar el espacio excesivo abajo */}
            <div className="px-6 pt-6 pb-2">
                <h1 className="text-xl font-bold text-gray-800 mb-4">{!readOnly ? 'Jefatura de Carrera' : 'Dirección Académica'} &gt; Consultas &gt; Estudiantes</h1>

                {/* Tabs */}
                <div className="flex gap-2">
                    <button
                        onClick={() => setActiveTab('admision')}
                        className={`flex items-center gap-2 px-4 py-2 rounded-full font-medium transition-colors ${activeTab === 'admision'
                            ? 'bg-blue-900 text-white'
                            : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                            }`}
                    >
                        Admisión
                    </button>
                    <button
                        onClick={() => setActiveTab('matriculacion')}
                        className={`flex items-center gap-2 px-4 py-2 rounded-full font-medium transition-colors ${activeTab === 'matriculacion'
                            ? 'bg-blue-900 text-white'
                            : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                            }`}
                    >
                        Licenciatura
                    </button>
                </div>
            </div>
            
            {/* Content */}
            <div className="pb-6">
                {activeTab === 'admision' ? (
                    <KardexEstAdmision readOnly={readOnly} hideHeader={true} />
                ) : (
                    <KardexEstMatriculacion readOnly={readOnly} hideHeader={true} />
                )}
            </div>
        </div>
    );
}